import { IConfigSeller } from '@/models/configSeller'
import { motion } from 'framer-motion'
import { useSelector } from 'react-redux'
import Certificate from './components/Certificate'
import Checklist from './components/Checklist'
import Client from './components/Client'
import Contract from './components/Contract'
import Detail from './components/Detail'
import DeviceMobile from './components/DeviceMobile'
import DeviceOther from './components/DeviceOther'
import Discounts from './components/Discounts'
import Header from './components/Header'
import History from './components/History'
import Multimedia from './components/Multimedia'
import Questions from './components/Questions'
import { TradeinProvider } from './context/TradeinContext'
import { useTradeinContext } from './hooks/useTradeinContext'
import { useTradeinFlags } from './hooks/useTradeinFlags'
import { webApiService } from '@/services'
import { IAppStore } from '@/models/store.model'
import { useAppDispatch } from '@/store/store'
import { updateUser } from '@/store/user'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import IAEvaluation from './components/IAEvaluation'
import Extras from './components/Extras'
import NovabencEvaluation from './components/NovabenchEvaluation'
import OsiptelEvaluation from './components/OsiptelEvaluation'

import { useJoyRide } from '@/utils/JoyRide'
import { JoyRideProvider } from './context/JoyRideContext'
import SwitchBattery from './components/SwitchBattery'
import { canShowIAEvaluation } from '@/utils/canShowIAEvaluation'

export const TradeInPageContext = ({ compact = false }: { compact?: boolean }) => {
  const { JoyRideComponent } = useJoyRide()
  const { ctx, saveCtx } = useTradeinContext()

  console.log('ctx => ', ctx)
  const configSeller = useSelector((store: { config: IConfigSeller }) => store.config)
  const {
    isSamsungPeru,
    isSamsungRomPeru,
    isFalabellaChile,
    isMacstoreMexico,
    isSamsungMexico,
    isHuaweiMexico,
    isTelcelMexico,
    isTelcelCorpMexico,
    isHuaweiPeru,
    isHuaweiChile,
    isHuaweiOnlineChile,
    isHuaweiOnlineMexico,
    isHuaweiOnlinePeru,
    isRipleyChile,
    isParisChile,
    isXiaomiMexico,
    isOppoMexico,
    isElektraMexico,
    isCoppelMexico,
    hasIAEvaluation,
    hasPhonecheck,
    isConsola,
    canEvaluateBatteryWithSwitch,
    useDiscountsByBatteryModel,
    showSwitchBattery,
    isNovabench
  } = useTradeinFlags()
  const userState = useSelector((store: IAppStore) => store.user)
  const dispatch = useAppDispatch()
  const { id } = useParams()

  const loadUSerStore = () => {
    saveCtx({ ...ctx, loading: true })
    webApiService.getStoreByUser(userState.id).then(res => {
      if (res.data.length > 0) {
        dispatch(updateUser({ ...userState, id_store: res.data[0].id }))
      }
    })
      .catch((error) => {
        saveCtx({ ...ctx, loading: false })
        console.log('Error loading data:', error)
      })
  }

  useEffect(() => {
    loadUSerStore()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  return (
    <motion.div
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.3 }} className='space-y-4'
    >
      {JoyRideComponent}
      <Header />
      {!compact && (
        <div className='grid grid-cols-12 gap-4 mt-4'>
          <div className='col-span-12 md:col-span-3'>
            <Detail />
          </div>
          <div className='col-span-12 md:col-span-9'>
            <Client />
            <div className='grid grid-cols-12 gap-4 mt-4'>
              <div className='col-span-12 md:col-span-8'>
                {ctx.tradein.sbu === 'Smartphone' || (ctx.tradein.sbu === 'Tablet' && ctx.tradein.brand === 'Apple') ? <DeviceMobile /> : <DeviceOther />}
              </div>
              <div className='col-span-12 md:col-span-4'>
                <History />
              </div>
            </div>
          </div>
        </div>
      )}
      <div className='grid grid-cols-12 gap-4 mt-4'>

        {ctx.tradein.id_status === 6 && (ctx.tradein.sbu === 'Smartphone' || (ctx.tradein.sbu === 'Tablet' && ctx.tradein.brand === 'Apple'))
          ? (
            <div className='col-span-12'><div className='text-sm p-4 bg-red-100 border border-red-300 rounded-md text-black'>Lo sentimos, este dispositivo no aprobó la evaluación de Phonecheck. Puede reenviar el código para realizar una nueva evaluación.</div></div>
            )
          : null}

        {
          ctx.tradein.id_status !== 6
            ? (
              <>
                <div className='col-span-12 md:col-span-12'>
                  <NovabencEvaluation />
                </div>
                <div className={configSeller.config.permisos.ENABLE_CHECK_BATTERY === 1 && (ctx.tradein.entry_form_status === 1 || ctx.tradein.certificate_theft === 'VALID') ? 'col-span-12 md:col-span-12' : 'col-span-12'}>
                  {ctx.tradein.sbu === 'Smartphone' || (ctx.tradein.sbu === 'Tablet' && ctx.tradein.brand === 'Apple')
                    ? <Certificate />
                    : <Checklist />}
                </div>

                {!isSamsungPeru &&
                  <div className='col-span-12'>
                    <Questions />
                  </div>}

                <div className='col-span-12'>
                  {canShowIAEvaluation(configSeller, ctx.tradein) ? <IAEvaluation showSwitchBattery={showSwitchBattery} useDiscountsByBatteryModel={useDiscountsByBatteryModel} /> : null}
                </div>

                {(isSamsungPeru) &&
                  <div className='col-span-12'>
                    <Questions />
                  </div>}

                {
                  isSamsungRomPeru &&
                    <div hidden={hasIAEvaluation && ctx.tradein.grade_IA === null} className={ctx.tradein.id_status !== 1 ? 'col-span-12 md:col-span-6' : 'col-span-12'}>
                      <OsiptelEvaluation />
                    </div>
                }
                {isSamsungPeru && !isConsola && !isSamsungRomPeru && configSeller.config.permisos.ENABLE_CHECK_BATTERY === 1 && canEvaluateBatteryWithSwitch &&
                  <div hidden={hasIAEvaluation && ctx.tradein.grade_IA === null} className={ctx.tradein.id_status !== 1 ? 'col-span-12 md:col-span-6' : 'col-span-12'}>
                    <Discounts />
                  </div>}

                {/* {
                  configSeller.config.permisos.ENABLE_CHECK_BATTERY === 1 && (ctx.tradein.entry_form_status === 1 || ctx.tradein.certificate_theft === 'VALID')
                    ? (
                      <div className='col-span-12 md:col-span-6'>
                        <Discounts />
                      </div>
                      )
                    : null
                } */}
                {!isSamsungPeru && !isNovabench && !isConsola && !isSamsungRomPeru && !isMacstoreMexico && ((isSamsungMexico) && ctx.tradein.sbu !== 'Smartwatch') && configSeller.config.permisos.ENABLE_CHECK_BATTERY === 1 && canEvaluateBatteryWithSwitch
                  ? (
                    <div hidden={hasIAEvaluation && ctx.tradein.grade_IA === null} className={ctx.tradein.id_status !== 1 ? 'col-span-12 md:col-span-6' : 'col-span-12'}>
                      <Discounts />
                    </div>
                    )
                  : null}

                {showSwitchBattery === true
                  ? (
                    <div hidden={hasIAEvaluation && ctx.tradein.grade_IA === null} className={ctx.tradein.id_status !== 1 ? 'col-span-12 md:col-span-6' : 'col-span-12'}>
                      <SwitchBattery />
                    </div>
                    )
                  : null}

                {
                    isSamsungRomPeru && ctx.tradein.osiptel_evaluation !== null && ctx.tradein.osiptel_evaluation !== 1 && configSeller.config.permisos.ENABLE_CHECK_BATTERY === 1 && (canEvaluateBatteryWithSwitch || (!canEvaluateBatteryWithSwitch && ctx.tradein.sbu.includes('Tablet'))) &&
                    // isSamsungRomPeru &&
                      <div hidden={hasIAEvaluation && ctx.tradein.grade_IA === null} className={ctx.tradein.id_status !== 1 ? 'col-span-12 md:col-span-6' : 'col-span-12'}>
                        <Discounts />
                      </div>
                  }
                {isMacstoreMexico && ctx.tradein.id_status === 4 && configSeller.config.permisos.ENABLE_CHECK_BATTERY === 1 && (canEvaluateBatteryWithSwitch || useDiscountsByBatteryModel || (!canEvaluateBatteryWithSwitch && ctx.tradein.sbu.includes('Tablet')))
                  ? (
                    <div hidden={(hasIAEvaluation && ctx.tradein.grade_IA === null) || (isMacstoreMexico && isNovabench)} className='col-span-12 md:col-span-6'>
                      <Discounts />
                    </div>
                    )
                  : null}
                {!isMacstoreMexico && !isSamsungRomPeru && !isSamsungPeru && ctx.tradein.id_status >= 3 && configSeller.config.permisos.ENABLE_CHECK_BATTERY === 1 && !isNovabench && !isConsola && canEvaluateBatteryWithSwitch
                  ? (
                    <div hidden={(hasIAEvaluation && ctx.tradein.grade_IA === null) || (isMacstoreMexico && isNovabench)} className='col-span-12 md:col-span-6'>
                      <Discounts />
                    </div>
                    )
                  : null}
                {/* El modulo de aumentos solo aplica si la cotizacion incluyo controles extra: sin controles
                    (0, null o el campo ausente, como en Mercado Libre, que ya no los pregunta) no se muestra. */}
                <div hidden={!isConsola || (hasIAEvaluation && ctx.tradein.grade_IA === null) || !ctx.tradein.extraControlsQuoted} className={ctx.tradein.id_status !== 1 ? 'col-span-12 md:col-span-6' : 'col-span-12'}>
                  <Extras />
                </div>

                {ctx.displayContract === 1 &&
                  <div className='col-span-12 md:col-span-6' hidden={((isNovabench && ctx.tradein.isBatteryHealthy && (isFalabellaChile || isMacstoreMexico) && [1].includes(ctx.tradein.id_status) && ctx.tradein.sbu === 'Notebook') || (hasIAEvaluation && ctx.tradein.grade_IA === null) || (isNovabench && (ctx.tradein.id_status === 1 || ctx.tradein.id_status === 2 || ctx.tradein.id_status === 4) && ctx.tradein.entry_form_status === 0) || (isSamsungRomPeru && (ctx.tradein.osiptel_evaluation === null || ctx.tradein.osiptel_evaluation === 1)) || (ctx.tradein.sbu === 'Tablet' && ctx.tradein.id_status === 1))}>
                    {/* // <div className='col-span-6' hidden={(hasIAEvaluation && ctx.tradein.grade_IA === null) || (isNovabench && (ctx.tradein.id_status === 1 || ctx.tradein.id_status === 2))}> */}
                    <Contract showSwitchBattery={showSwitchBattery} />
                  </div>}

                {isSamsungPeru &&
                  <div className='col-span-12' hidden={(hasIAEvaluation && ctx.tradein.grade_IA === null) || (isNovabench && (ctx.tradein.id_status === 1 || ctx.tradein.id_status === 2 || ctx.tradein.id_status === 4))}>
                    <Multimedia />
                  </div>}
                {/* {
                  (ctx.displayContract === 0 && ctx.tradein.id_status === 4 && ctx.tradein.isBatteryHealthy !== null) || (ctx.tradein.id_status !== 1 && ctx.tradein.id_status !== 2 && ctx.tradein.id_status !== 4)
                    ? (<div className='col-span-12'>  <Multimedia /> </div>)
                    : null
                } */}

                {!isSamsungPeru &&
                  <div className='col-span-12' hidden={(hasIAEvaluation && ctx.tradein.grade_IA === null) || (isNovabench && (ctx.tradein.id_status === 1 || ctx.tradein.id_status === 2 || ctx.tradein.id_status === 4)) || (isSamsungRomPeru && ctx.tradein.osiptel_evaluation === null) || (isSamsungRomPeru && (ctx.tradein.osiptel_evaluation === null || ctx.tradein.osiptel_evaluation === 1)) || isSamsungMexico || isHuaweiMexico || isHuaweiPeru || isHuaweiChile || isRipleyChile || isTelcelMexico || isTelcelCorpMexico || isParisChile || isHuaweiOnlineChile || isHuaweiOnlineMexico || isHuaweiOnlinePeru || isXiaomiMexico || isOppoMexico || isElektraMexico || isCoppelMexico || (isFalabellaChile && hasPhonecheck)}>
                    {/* // <div className='col-span-12' hidden={(hasIAEvaluation && ctx.tradein.grade_IA === null) || (isNovabench && (ctx.tradein.id_status === 1 || ctx.tradein.id_status === 2 || ctx.tradein.id_status === 4))}> */}
                    <Multimedia />
                  </div>}
              </>
              )
            : null
        }

      </div>
    </motion.div>
  )
}

const TradeInPage = () => {
  return (
    <JoyRideProvider>
      <TradeinProvider>
        <TradeInPageContext />
      </TradeinProvider>
    </JoyRideProvider>
  )
}

export default TradeInPage
